import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Stack,
} from '@mui/material';
import {
  ExpandMore,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { isDrawerOpen, selectIsDrawerOpen, selectUserDetail, userDetail } from '../redux/slice/userSlice';
import { IconMenuDeep } from '@tabler/icons-react';
import { lightPalette } from '../theme-layout/palette';
import { useNavigate } from 'react-router-dom';
import urlConstant from '../constants/urlConstants';
import apiClient from '../lib/api';

const Header = ({ title }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const getUserdetail = useSelector(selectUserDetail);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getIsDrawerOpen = useSelector(selectIsDrawerOpen);
  const [profileImagePath,setProfileImagePath] = useState(null);
  
  useEffect(()=>{
    if(getUserdetail?.profileImageName !== ""){
      setProfileImagePath(`${urlConstant.ProfileImage.ProfileImageUrl}${getUserdetail.profileImageName}`);
    }else{
      setProfileImagePath(null)
    }
  },[getUserdetail]);
  
  const handleDrawerToggle = () => {
    dispatch(isDrawerOpen({ isDrawerOpen: !getIsDrawerOpen }));
  };

  const handleProfileMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    const requestObject = {
      windowId : localStorage.getItem("windowId") ?? "",
      userId: getUserdetail?.userId
    }
    apiClient.post(urlConstant.Login.UserLogout, requestObject,{authRequired: true }).then((response) => {})
    .catch((error) =>{
      console.error(error)
    })
    .finally(() => {
      handleMenuClose();
      dispatch(userDetail({ userDetail: {} }));
      localStorage.removeItem("accessToken")
      localStorage.removeItem("windowId")
      localStorage.removeItem("refreshToken")
      navigate("/login")
    })
  }

  return (
    <>
      <AppBar
        position='static'
        sx={{
          backgroundColor: 'transparent',
          color: lightPalette.default.main,
          boxShadow: "none",
        }}
      >
        <Toolbar variant='dense' disableGutters sx={{ justifyContent: 'space-between' }}>
          <Stack direction='row' alignItems="center" gap={{ xs: 1, sm: 2 }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleDrawerToggle}
              sx={{ display: getIsDrawerOpen ? "none" : "inline-flex" }}
            >
              <IconMenuDeep color={lightPalette.primary.main} />
            </IconButton>
            <Typography variant="h4" fontSize={{ xs: 16, sm: 24 }} noWrap>
              {title}
            </Typography>
          </Stack>
          <IconButton sx={{ display: { xs: 'block', sm: 'none' } }} size="small" onClick={handleProfileMenu}>
            <Avatar alt={getUserdetail?.firstName} src={profileImagePath}>{!profileImagePath && getUserdetail?.firstName && `${getUserdetail?.firstName[0]}`}</Avatar>
          </IconButton>
          <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 1 ,cursor: 'pointer',}} onClick={handleProfileMenu} onClose={handleMenuClose}>
            <Avatar alt={getUserdetail?.firstName} src={profileImagePath}>{!profileImagePath && getUserdetail?.firstName && `${getUserdetail?.firstName[0]}`}</Avatar>
            <Typography variant="subtitle2">{getUserdetail?.firstName + " " + getUserdetail?.lastName}</Typography>
            <ExpandMore />
          </Box>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => { handleMenuClose();   navigate("/profile")}}>My Profile</MenuItem>
              <MenuItem onClick={() => { handleMenuClose();   navigate("/change-password")}} >Change Password</MenuItem>
              <MenuItem onClick={() => handleLogout()}>
                Logout
              </MenuItem>
            </Menu>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;